export default __webpack_public_path__ + "static/media/Animations_Circle8.ab17efc1.svg";